import React from 'react';
import DocumentTitle from 'react-document-title';

import Focus from './Focus';
import Favicon from './Favicon';
import Header from '../header/header';
import Modal from '../Modal';
import Video from '../Video';
import Toast from '../Toast';
import Tips from '../Tips';

import { withRouter } from "react-router";

import 'normalize.css';
import './index.css';
import {getUrlQeury} from "~/misc/formatUrlquery";
import store from "~/store";
import {updateGlobalParams} from "~/modules/window/actions";

class root extends React.Component {

  globalUrlParamsControl() {
    store.dispatch(updateGlobalParams());
  }
  render() {
    this.globalUrlParamsControl()

    return (<div id='app-root'>
      <DocumentTitle title='Truckloads Carriers' />
      <Favicon/>
      <Focus/>
      <Header/>
      {this.props.children}
      <Modal/>
      <Video/>
      <Toast/>
      <Tips/>
    </div>)
  }
}

export default withRouter(root);



// WEBPACK FOOTER //
// ./src/components/root/index.js